import React, { useState, useEffect, useCallback } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";
import SuiAvatar from "components/SuiAvatar";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../../auth-context/auth.context";

const AVATAR_CACHE_KEY = "userAvatarCache";

const AvatarBadge = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [avatarData, setAvatarData] = useState(() => {
    const cachedData = localStorage.getItem(AVATAR_CACHE_KEY);
    return cachedData ? JSON.parse(cachedData) : { initials: "", imageUrl: null };
  });
  const [imageError, setImageError] = useState(false);
  const open = Boolean(anchorEl);
  const history = useHistory();
  const { user, profileImage } = useAuth();

  const calculateInitials = useCallback((userData) => {
    if (userData?.nombres && userData?.apellidos) {
      return `${userData.nombres[0]}${userData.apellidos[0]}`.toUpperCase();
    }
    return userData?.email?.[0].toUpperCase() || "?";
  }, []);

  useEffect(() => {
    if (user) {
      const initials = calculateInitials(user);
      const newAvatarData = { initials, imageUrl: profileImage };
      setAvatarData(newAvatarData);
      localStorage.setItem(AVATAR_CACHE_KEY, JSON.stringify(newAvatarData));
    }
  }, [user, profileImage, calculateInitials]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    handleMenuClose();
    history.push("/perfil");
  };

  const handleLogout = () => {
    handleMenuClose();
    localStorage.removeItem(AVATAR_CACHE_KEY);
    history.push("/authentication/sign-out");
  };

  const handleImageError = () => {
    setImageError(true);
    const newAvatarData = { ...avatarData, imageUrl: null };
    setAvatarData(newAvatarData);
    localStorage.setItem(AVATAR_CACHE_KEY, JSON.stringify(newAvatarData));
  };

  const renderAvatar = () => (
    <SuiAvatar
      size="sm"
      customClass="shadow-sm"
      style={{
        backgroundColor: "#E0E0E0",
        color: "#333",
        fontWeight: "bold",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        height: "32px",
      }}
    >
      {!imageError && avatarData.imageUrl ? (
        <img
          src={avatarData.imageUrl}
          alt="profile"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          onError={handleImageError}
        />
      ) : (
        avatarData.initials
      )}
    </SuiAvatar>
  );

  return (
    <>
      <IconButton onClick={handleMenuOpen} color="inherit">
        {renderAvatar()}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleProfile}>
          <Icon sx={{ mr: 1 }}>person</Icon>
          Perfil
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <Icon sx={{ mr: 1 }}>logout</Icon>
          Cerrar Sesión
        </MenuItem>
      </Menu>
    </>
  );
};

export default AvatarBadge;
